'use client';
import React from 'react';
import FlowbiteContext from './context/FlowbiteContext';
import localFont from 'next/font/local';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './styles/globals.css';
import MwIcons from '@/components/icons';
import dynamic from 'next/dynamic';
import 'react-toastify/dist/ReactToastify.css';
import Image from 'next/image';

const proximaNova = localFont({
    src: [
        {
            path: './fonts/proxima-nova-regular.woff2',
            weight: '400',
            style: 'normal',
        },
        {
            path: './fonts/proxima-nova-medium.woff2',
            weight: '500',
            style: 'normal',
        },
        {
            path: './fonts/proxima-nova-semibold.woff2',
            weight: '600',
            style: 'normal',
        },
        {
            path: './fonts/proxima-nova-bold.woff2',
            weight: '700',
            style: 'normal',
        },
    ],
    display: 'swap',
    variable: '--mw-font-family',
});

const Footer = dynamic(() => import('@/components/footer'));

export default function NotFound() {
    return (
        <div className={`${proximaNova.variable} font-sans`}>
            <FlowbiteContext>
                <section className="bg-hero min-h-fit h-auto pb-16">
                    <div className="container lg:container md:mx-auto top-hero">
                        <div className="text-center lg:w-6/12 mx-auto">
                            <Image
                                src="/img/img-error.svg"
                                alt="404"
                                title="404"
                                height="415"
                                width="460"
                                loading="lazy"
                                className="mb-5 img-fluid"
                                unoptimized
                            />
                            <h1 className="fs-xl mb-4 dark:text-textcolor">Oops! Page not found</h1>
                            <p className="fs-md text-black mb-5">
                                We&apos;re sorry we have lost our spark or this page does not exist. Try the links below to start
                                your experience again.
                            </p>
                            <div>
                                <span
                                    className="btn btn-primary mr-5 cursor-pointer"
                                    onClick={() => {
                                        window.location.href = '/';
                                    }}
                                >
                                    Go Home
                                </span>
                                <span
                                    className="btn btn-warning cursor-pointer"
                                    onClick={() => {
                                        window.location.href = '/contact-us';
                                    }}
                                >
                                    Contact Us
                                </span>
                            </div>
                        </div>
                    </div>
                </section>

                <Footer />
                <MwIcons />
            </FlowbiteContext>
        </div>
    );
}
